export type RequiredFieldsTypes = 'string' | 'object' | 'array' | 'number' | 'boolean';

export const Types = {
	string: 'Coach.Model.Type.String',
	object: 'Coach.Model.Type.Object',
	array: 'Coach.Model.Type.Array',
	number: 'Coach.Model.Type.Number',
	boolean: 'Coach.Model.Type.Boolean',
};

export default class AbstractModel {
	public static type: string = '<AbstractModel>';
	public static requiredFields: any;
	public static defaultValues: any;
	public _data: any;
	public requiredFields: any;
	public defaultValues: any;

	constructor(data: Object = {}) {
		this._data = data;
	}

	public init(): AbstractModel {
		this.setDefaultValues();
		this.transform();
		this.validate();

		return this;
	}

	public get(): Object {
		return this._data;
	}

	public getType() {
		return (this.constructor as any).type ? (this.constructor as any).type : this.constructor.name;
	}

	/*
	 * @abstract
	 */
	public transform() {}

	public shouldInstanciate(data: Object, ClassDefinition: any): Object {
		if (data) {
			return new ClassDefinition(data);
		}

		return data;
	}

	public mapShouldInstanciate(dataMap: Object[], ClassDefinition: any): Array<any> {
		const instanciator = this.shouldInstanciate;

		if (dataMap && dataMap.length > 0) {
			return dataMap.map((data: Object) => instanciator(data, ClassDefinition));
		}

		return [];
	}

	public getDefaultValue(field: string): any {
		const requiredFields = (this.constructor as any).requiredFields;
		const defaultValues = (this.constructor as any).defaultValues;

		if (requiredFields && defaultValues) {
			return defaultValues[field];
		}

		return void 0;
	}

	public setDefaultValues(): Object {
		const data = this._data;
		const defaultValues = (this.constructor as any).defaultValues;

		if (typeof defaultValues !== 'object') {
			return data;
		}

		const defaultKeys = Object.keys(defaultValues) || [];

		defaultKeys.forEach((key: string) => {
			data[key] = data[key] ? data[key] : defaultValues[key];
		});

		return (this._data = data);
	}

	public validate(): boolean {
		// const _this = this;
		// const requiredFields = (this.constructor as any).requiredFields;

		// if (!requiredFields) {
		// 	return true;
		// }

		// const requiredFieldsKeys = Object.keys(requiredFields);

		// const invalidFields = [];
		// let isTypeSave = false;
		// let fieldType: RequiredFieldsTypes;

		// if (!requiredFields || requiredFieldsKeys.length === 0) {
		// 	return true;
		// }

		// for (const name in requiredFields) {
		// 	if (!requiredFields.hasOwnProperty(name)) {
		// 		return true;
		// 	}

		// 	fieldType = requiredFields[name];
		// 	isTypeSave = null;

		// 	if (fieldType === Types.array) {
		// 		isTypeSave = Array.isArray(_this._data[name]);
		// 	}

		// 	if (fieldType === Types.number) {
		// 		isTypeSave = !isNaN(_this._data[name]);
		// 	}

		// 	if (fieldType === Types.object) {
		// 		isTypeSave = typeof _this._data[name] === 'object';
		// 	}

		// 	if (typeof fieldType === 'string' && ~fieldType.indexOf('[') && ~fieldType.indexOf(']')) {
		// 		fieldType = fieldType.replace('[', '').replace(']', '');
		// 		fieldType = fieldType.split(',');
		// 		isTypeSave = ~fieldType.indexOf(_this._data[name]);
		// 	}

		// 	if (fieldType === Types.string) {
		// 		isTypeSave = typeof _this._data[name] === 'string';
		// 	}

		// 	if (isTypeSave === null) {
		// 		try {
		// 			isTypeSave = typeof _this._data[name] === fieldType;
		// 		} catch (err) {

		// 			isTypeSave = false;
		// 		}
		// 	}

		// 	if (!isTypeSave) {
		// 		invalidFields.push(name);
		// 	}
		// }

		// const invalidFieldCount = invalidFields.length;

		// if (invalidFieldCount > 0) {
		// 	throw new Error(
		// 		`Invalid field${invalidFields.length > 1 ? 's' : ''} detected in Model ${this.constructor.name}: ` +
		// 			`${invalidFields.map(field => `"${field}"`).join(', ')}\n` +
		// 			`Types should match the following: ${invalidFields
		// 				.map(name => `[${name}:${requiredFields[name].toString()}(${typeof _this._data[name]})]`)
		// 				.join(', ')}`
		// 	);
		// }

		return true;
	}
}
